import React, { useState } from "react";
import "./LeverageList.css";

export default function LeverageList() {
  const [leverages] = useState([
    { id: 1, leverage: 100, status: "Active", updatedAt: "Thursday, January 01, 1970 04:00:00 AM", updatedBy: "Super Admin" },
    { id: 2, leverage: 200, status: "Active", updatedAt: "Thursday, January 01, 1970 04:00:00 AM", updatedBy: "Super Admin" },
    { id: 3, leverage: 300, status: "Active", updatedAt: "Thursday, January 01, 1970 04:00:00 AM", updatedBy: "Super Admin" },
    { id: 4, leverage: 400, status: "Active", updatedAt: "Thursday, January 01, 1970 04:00:00 AM", updatedBy: "Super Admin" },
    { id: 5, leverage: 500, status: "Active", updatedAt: "Thursday, January 01, 1970 04:00:00 AM", updatedBy: "Super Admin" },
    { id: 6, leverage: 1000, status: "Inactive", updatedAt: "Monday, March 03, 2025 09:27:41 PM", updatedBy: "Super Admin" },
  ]);

  return (
    <div className="leverage-page">
      {/* Header */}
      <div className="page-header">
        <h2>Leverage List</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / View All
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h4>View all leverages</h4>

        {/* Top actions */}
        <div className="table-actions">
          <div className="left-buttons">
            <button>Copy</button>
            <button>CSV</button>
            <button>Excel</button>
            <button>PDF</button>
            <button>Print</button>
          <button className="dropdown-btn">Column visibility ▾</button>
    
          </div>
          <div className="right-actions">
            <button className="btn-create">+ Create New</button>
            <label>
              Search: <input type="text" />
            </label>
          </div>
        </div>

        {/* Table */}
        <table className="styled-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Leverage</th>
              <th>Status</th>
              <th>Last Updated at</th>
              <th>Last Updated By</th>
              <th>Actions</th>
            </tr>
          </thead>
          {/* <tbody>
            {leverages.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.leverage}</td>
                <td>
                  <span
                    className={`status ${
                      item.status === "Active" ? "active" : "inactive"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td>{item.updatedAt}</td>
                <td>{item.updatedBy}</td>
                <td className="actions">
                  {item.status === "Active" ? (
                    <button className="btn-yellow">
                      <i className="fas fa-eye-slash"></i>
                    </button>
                  ) : (
                    <button className="btn-green">
                      <i className="fas fa-eye"></i>
                    </button>
                  )}
                  <button className="btn-blue">
                    <i className="fas fa-edit"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody> */}
        </table>

        {/* Footer Pagination */}
        <div className="table-footer">
          {/* <p>Showing 1 to {leverages.length} of {leverages.length} entries</p> */}
          <div className="pagination">
            <button disabled>Previous</button>
            <button className="active">1</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="page-footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </footer>
    </div>
  );
}
